import { FC, PropsWithChildren } from 'react';
import { Text } from '../../../../typography/text';
import { Subheadline } from '../../../../typography/subheadline';
import { Mode, Size } from '../../enums';

type Props = PropsWithChildren<{
  mode: Mode;
  size: Size;
}> &
  HasClassName;

export const Entry: FC<Props> = ({ mode, size, className, children }) => {
  if (mode === Mode.LINK) {
    return (
      <Text className={className} weight={3}>
        {children}
      </Text>
    );
  }

  if (size === Size.LARGE) {
    return (
      <Text className={className} weight={2}>
        {children}
      </Text>
    );
  }

  return (
    <Subheadline className={className} level={2} weight={2}>
      {children}
    </Subheadline>
  );
};
